import FaultReportService from '../service/faultReport'
const state = {
    query: {
        customer: "",
        point: "",
        page: 1,
        pageSize: 10,
    },
    loading: false,
    searchResult: {
        total: 0,
        faultReports: [],
    },
}

const actions = {
    createFaultReport({ commit }, faultReport) {
        return FaultReportService.createFaultReport(faultReport).then(data => {
            faultReport._id = data._id;
            commit('addFaultReport', faultReport);
            return data;
        })
    },
    deleteFaultReport({ commit }, id) {
        return FaultReportService.deleteFaultReport(id).then(() => {
            commit('removeFaultReport', id);
            return id;
        })
    },
    getFaultReports({ commit }, query) {
        commit('setLoading', true)
        return FaultReportService.getFaultReports(query).then(res => {
            commit('setFaultReports', res);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addFaultReport(state, faultReport) {
        state.searchResult.faultReports.push(faultReport)
    },
    removeFaultReport(state, id) {
        var index = state.searchResult.faultReports.findIndex(x => x._id == id)
        if (index) {
            state.searchResult.faultReports.splice(index, 1)
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setFaultReports(state, triggers) {
        state.searchResult = triggers
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



